if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      var itgsubmitButton = this.querySelector('[type="submit"]');
      var itg_form = itgsubmitButton.closest('form');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
	  
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(itg_form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
        if( $(document).find('body').hasClass('data-cart-drawer') ){
          if (window.location.pathname.indexOf('/cart') !== -1) {
            location.href="/cart";
          }else{
            $("body").addClass("scroll-fixed");
            $(".cart-notification__links").removeClass("hidden");
            $(".quickview-model").removeClass('open');
            this.cartNotification.renderAContents(response);   
          }
        }else{          
          if( $(document).find('body').hasClass('data-cart-page') ){
            	location.href="/cart";
          }else{  
            $(".quickview-model").removeClass('open');
            $('.model-overlay').removeClass('active');
             $('body').removeClass('scroll-fixed');
            $(".cart-notification__links").removeClass("hidden");
          	this.cartNotification.renderContents(response);   
          }
        }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function ProductSlider() {
  if($(document).find('.productSlider').length){
    var numSlick = 0;
    $('.productSlider').each( function() {
      numSlick++;
      $(this).addClass('productSlider-'+numSlick).not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow:'<button type="button" class="slick-prev"><svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next"><svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>',
        asNavFor: '.productThumbnail-'+numSlick
      });
    });
  }
  if($(document).find('.productThumbnail').length){
    numSlick = 0;
    $('.productThumbnail').each( function() {
      numSlick++;
      $(this).addClass('productThumbnail-'+numSlick).not('.slick-initialized').slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        asNavFor: '.productSlider',
        dots: false,
        focusOnSelect: true,
        verticalSwiping:true,
        arrows: false,
        asNavFor: '.productSlider-'+numSlick,
        prevArrow:'<button type="button" class="slick-prev"><svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next"><svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>',
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              vertical: false,
              verticalSwiping:false,
              arrows: false,
            },
          },
        ]
      });
      if($(this).attr('data-slick')){
        $(this).slick('resize');
      }
    });
  }
}
ProductSlider();
document.addEventListener('DOMContentLoaded', function() {  
   ProductSlider();
});
document.addEventListener("shopify:section:load", function() {  
  ProductSlider();
});
document.addEventListener("shopify:section:unload", function() { 
  ProductSlider();
});
